import React from 'react'
import { TablePagination } from '@mui/material'
import { Pager } from './types'
import { useTranslation } from 'react-i18next'

const rowsPerPageOptions = [10, 20, 50, 100]

type PaginationProps = {} & Pager

export function Pagination(props: PaginationProps) {
  const { t } = useTranslation()

  const [rowsPerPage, setRowsPerPage] = React.useState<number>(
    props.rowsPerPage || rowsPerPageOptions[0]
  )

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>): void => {
    if (props.handleChangeRowsPerPage) {
      setRowsPerPage(parseInt(event.target.value))
      props.handleChangeRowsPerPage(event)
    }
  }

  return (
    <TablePagination
      labelDisplayedRows={() => ''}
      component="div"
      labelRowsPerPage={t('resultsPerPage')}
      count={props.count}
      page={props.page}
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={rowsPerPageOptions}
      onPageChange={props.handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      sx={{
        border: 0,
        fontSize: '13px',
        color: 'var(--gray-medium)',
        display: 'flex',
        justifyContent: 'space-between',
        overflow: 'hidden',
        '& > *': {
          margin: 'auto',
        },
        '& .MuiTablePagination-caption': {
          fontSize: '13px',
          color: 'var(--gray-medium)',
          marginBottom: 0,
        },
        '& .MuiTablePagination-selectLabel': {
          marginBottom: 0,
        },
        '& .MuiTablePagination-select': {
          border: 'none',
          borderRadius: '3px',
        },
        '& .MuiTablePagination-actions button': {
          color: (theme) => {
            const isPrevDisabled = props.page === 0
            const isNextDisabled = props.count - (props.page + 1) * rowsPerPage <= 0
            return isPrevDisabled || isNextDisabled ? '#b5b8c4' : 'var(--green-light)'
          },
          border: 'none',
          borderRadius: '3px',
          width: '30px',
          height: '30px',
        },
      }}
    />
  )
}
